import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index'
import services from '../views/services'
import admin from '../views/14344'
import betalicense from '../views/betalicense'
import faq from '../views/faq'
import cfront from '../components/cfront'
import amcertf from '../components/amcertf'

Vue.use(VueRouter)
Vue.use(require('vue-moment'));

  const routes = [
  {
    path: '/',
    name: 'index',
    component: index
  },
  {
    path: '/14344',
    name: '14344',
    component: admin
  },
  {
    path: '/services',
    name: 'services',
    component: services
  },
  {
    path: '/betalicense',
    name: 'betalicense',
    component: betalicense
  },
  {
    path: '/amcertf',
    name: 'amcertf',
    component: amcertf
  },
  {
    path: '/faq',
    name: 'faq',
    component: faq
  },
  {
    path: '/cfront/',
    name: 'faq',
    component: cfront
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
